































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesOrderItemView extends Vue {
  public createPurchaseOrder = Components.CreatePurchaseOrder;
  public items: Common.SalesOrderItem[] = new Array(0);
  public params: Common.OrderItemQuery = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.OrderItemImportQuery('受注明細',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.OrderItemExportQuery('受注明細', this.params,Common.SalesPurchaseFlags.Sales);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'orderItemNo', text: '明細番号' },
    { value: 'orderDate', text: '受注日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'commodity', text: '商品' },
    { value: 'sku', text: 'SKU' },
    { value: 'uom', text: '単位' },
    { value: 'quantity', text: '受注数量' },
    { value: 'answerDeliveryDate', text: '回答納期' },
    { value: 'scheduledDeliveryDate', text: '出荷予定日' },
    { value: 'orderNo', text: '受注番号' },
    { value: 'supplier', text: '発注先' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'refNo', text: '受注管理番号' },
    { value: 'customerOrderNo', text: '顧客注文番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;
  public visibleTypes = Common.visibleTypes;
  public updateDeliveryDate = Components.UpdateDeliveryDate;

  public dispFlag: number = Common.InputTypes.SalesDelivery;
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.OrderItemStatus;    
  @Prop() public scheduledDeliveryDateTo: Date;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listVisbles = new Array();  
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  
  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 5, this.$api.useStockFunction); // 予備項目タブ

    // :gridCaptions="['状態', '明細ID', '受注番号', '行番号', '明細番号', '受注日', '部門', '得意先', '担当者', '商品', '商品名称', '棚卸対象外', '単位', 'SKU', '受注数量','取引通貨', '単価', '税区分', 'NCV', '取引金額', '備考', '発注先',
    // '回答納期', '出荷予定日', '受注残数量', '受注残数量(計上単位)', '引当待ち数量', '発注残数量', '引当済数量', 'クローズ数量', '管理番号', '顧客注文番号', 'ワークフロー', '初回保存日', '初回保存者', '最終更新日', '最終更新者']"
    // :gridWidths="[170, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150,  150, 150, 150, 150, 150, 150,150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150]"

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 140),
      new Common.GridItemConfiguration('受注日', 100),
      new Common.GridItemConfiguration('得意先', 180),
      new Common.GridItemConfiguration('商品', 180),
      new Common.GridItemConfiguration('SKU', 150),   
      new Common.GridItemConfiguration('単位', 100),           
      new Common.GridItemConfiguration('受注数量', 120),      
      new Common.GridItemConfiguration('回答納期', 120),
      new Common.GridItemConfiguration('出荷予定日', 120),   
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('単価', 120),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('上代単価', 120),
      new Common.GridItemConfiguration('仕入単価', 120),
      new Common.GridItemConfiguration('粗利', 120),
      new Common.GridItemConfiguration('発注先', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),            
      new Common.GridItemConfiguration('受注番号', 150),            
      // new Common.GridItemConfiguration('明細ID', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      // new Common.GridItemConfiguration('備考', 150),           
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),         
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('引当済数量', 150),
      new Common.GridItemConfiguration('クローズ数量', 150),           
      new Common.GridItemConfiguration('受注残数量', 150),
      new Common.GridItemConfiguration('引当待ち数量', 150),      
      new Common.GridItemConfiguration('入荷待ち数量', 150),
      new Common.GridItemConfiguration('受注残数量(計上単位)', 150),                
      new Common.GridItemConfiguration('受注管理番号', 150),              
      new Common.GridItemConfiguration('顧客注文番号', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),          
    );
    //予備項目追加〜非表示
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.listVisbles = this.gridConfig.gridVisibles;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    // 検索条件を設定する
    if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.orderItemNo) {
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.scheduledDeliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
        
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;       
    if (this.scheduledDeliveryDateTo)this.params.scheduledDeliveryDateTo = this.scheduledDeliveryDateTo;        
    
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseOrder');
    this.$api.formatter.ensureListLoaded('workflow_salesDelivery');
  }

  // public beforeRouteUpdate(to:any, from:any, next :Function){
  //   Common.QueryParamUtility.loadQueryParams(to,from,next);
  // }
  // public beforeRouteEnter (to:any, from:any, next :Function) {
  //   Common.QueryParamUtility.loadQueryParams(to,from,next);
  // }

  public async onCreate(obj: Common.SalesOrderItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_salesOrderItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.SalesOrderItem){
    this.$api.execute(new Common.OrderGetItemPriceQuery(item.order, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 受注数量の最小値を取得する
  public getMinQuantity(item:Common.SalesOrderItem){
    let minQuantity = item.allocatedQuantity + item.purchasePendingQuantity + item.closedQuantity;
    if(minQuantity != 0) return minQuantity;
    if(item.commodity && item.commodity.isNoStock) return -99999999.999;
    else return 0;
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.SalesOrderSaving) return true;
    if(state == Common.OrderItemStatus.SalesOrderWaiting) return true;
    return false;
  }
  // 状態が失注か判別する
  public isStateLost(state: Common.OrderItemStatus):boolean{
    return state == Common.OrderItemStatus.SalesOrderLost;
  }
  public isComplete(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.SalesOrderCompleted) return true;
    return false;
  }

  // 一覧でチェックされている受注明細
  public checkedOrderItems: Array<Common.SalesOrderItem>= new Array(0);
  public getCheckedOrderItems(){
    this.checkedOrderItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedOrderItems.push(obj);
      }
    });
  }

  // 納期更新用プロパティ
  // public uddAnswerDeliveryDate:Date = null;
  // public uddScheduledDeliveryDate:Date = null;

  // // 納期更新ダイアログの表示
  public showUpdateDeliveryDateDialog() {
    this.getCheckedOrderItems();
    
    let componentClass = Vue.extend(this.updateDeliveryDate);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList:this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);


  //   // ダイアログ表示前バリデーション
  //   if(this.checkedOrderItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
  //     return;
  //   }
  //   if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
  //     this.$api.modal.show('', 'サブスクリプション明細の納期更新は行えません。', true, null);
  //     return;
  //   }    
  //   // プロパティの初期化
  //   this.uddAnswerDeliveryDate = null;
  //   this.uddScheduledDeliveryDate = null;

  //   // ダイアログを表示
  //   (this.$refs.updateDeliveryDateDialog as Components.ListDialog).showDialog();
  }

  // // 納期更新の実行
  // public async submitUpdateDeliveryDate() {
  //   // クエリの設定
  //   var query = new Common.UpdateDeliveryDateQuery();
  //   query.orderItems = this.checkedOrderItems;
  //   query.answerDeliveryDate = this.uddAnswerDeliveryDate;
  //   query.scheduledDeliveryDate = this.uddScheduledDeliveryDate;

  //   // 納期更新の実行
  //   await this.$api.execute(query).then(res => {
  //     this.refreshListView();
  //   });
  // }

  public uddSubscriptionEndDate:Date = null;
  // 契約日更新
  public showUpdateSubscriptionEndDate(){
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length <= 0){
      this.$api.modal.show('', 'サブスクリプション明細を選択して下さい。', true, null);
      return;
    }    
    // プロパティの初期化
    this.uddSubscriptionEndDate = null;

    // ダイアログを表示
    (this.$refs.updateSubscriptionEndDateDialog as Components.ListDialog).showDialog();
  }
  // 契約日更新の実行
  public async submitSubscriptionEndDate() {
    // クエリの設定
    var query = new Common.UpdateSubscriptionEndDateQuery();
    query.orderItems = this.checkedOrderItems.filter(item => item.order.isSubscription);
    query.subscriptionEndDate = this.uddSubscriptionEndDate;

    // 契約日更新の実行
    await this.$api.execute(query).then(res => {
      this.refreshListView();
    });
  }

  // 引当処理用プロパティ
  public adInputType:Common.InputTypes = Common.InputTypes.SalesOrder;
  public adCaptions = new Array();
  public adWidths = new Array();
  public adSlots = new Array();
  public adGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('倉庫', 200),
      new Common.GridItemConfiguration('予定在庫数量', 200),
      new Common.GridItemConfiguration('在庫単価', 200),
      new Common.GridItemConfiguration('出荷数量', 200),
      new Common.GridItemConfiguration('出荷日', 200),
    ],
    1, // 倉庫の次を予備項目の挿入位置に指定
    'col'
  );
  public adOrderItem: Common.SalesOrderItem = new Common.SalesOrderItem();
  public adBackSalesOrderQuantity = 0;
  public adAllocationQuantity = 0;
  public adScheduledDeliveryDate = new Date();
  public adListStockBalanceNoStock = new Array();

  // 引当処理用バリデーション
  public validateForAllocation(orderItem: Common.SalesOrderItem):string{
    if (orderItem == null){
      return '引当可能な明細を選択して下さい。';
    }
    //ステータス変更にともないコメント
    // if(orderItem.isNoStock == false){
    //   if (orderItem.state != Common.OrderItemStatus.SalesOrderUnallocated && orderItem.state != Common.OrderItemStatus.SalesOrderAllocating && orderItem.state != Common.OrderItemStatus.SalesOrderAllocatingArrivalWaiting){
    //     return '引当可能な明細を選択して下さい。';
    //   }
    // }else{
    //   if (orderItem.state != Common.OrderItemStatus.SalesOrderUndelivered && orderItem.state != Common.OrderItemStatus.SalesOrderDelivering){
    //     return '引当可能な明細を選択して下さい。';
    //   }
    // }
    //ステータス変更にともない条件変更
    if (orderItem.state  < Common.OrderItemStatus.SalesOrderUnallocated){
      return '受注一覧で受注確定がされた明細を選択して下さい。';
    }
    if(orderItem.backSalesOrderQuantity == 0){
      return '受注残数量のある明細を選択し、引当処理をしてください。';
    }
    if(orderItem.scheduledDeliveryDate == null){
      return '出荷予定日を入力して下さい。';
    }
    return '';
  }

  // 引当処理ダイアログの表示
  public showAllocateDialog() {
   this.getCheckedOrderItems();

    if(this.checkedOrderItems.length > 1){
      this.$api.modal.show('', '単一の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の出荷引当は行えません。', true, null);
      return;
    } 

    const temp =  this.checkedOrderItems[0] as Common.SalesOrderItem;
    this.adOrderItem = temp as Common.SalesOrderItem;
  
    // ダイアログ表示前バリデーション
    var message: string = this.validateForAllocation(this.adOrderItem);
    if(message.length > 0){
      this.$api.modal.show('', message, true, null);
      return;
    }

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(false,true,false,false,false);//在庫識別情報
    this.adGridConfig.setVariableItems(reserveItems);
    this.adCaptions =this.adGridConfig.gridCaptions;
    this.adWidths = this.adGridConfig.gridWidths;
    this.adSlots = this.adGridConfig.gridSlots;
    this.adBackSalesOrderQuantity = temp.backSalesOrderQuantity;
    
    // クエリの設定
    var query = new Common.StockBalanceAllocateQuery();
    query.orderItem = temp as Common.OrderItem;

    if(this.adOrderItem.commodity != null && this.adOrderItem.commodity.isNoStock)
    {
      // 在庫情報をロードする（棚卸対象外のダミー1行分のみ）
      // サーバー側でインスタンスを作成しないとサーバー側でのデシリアライズに失敗してしまう
      this.$api.execute(query).then(res => {
        this.adListStockBalanceNoStock = (res as Common.LoadResult).result;
        this.adAllocationQuantity = 0;
        this.adScheduledDeliveryDate = this.adOrderItem.scheduledDeliveryDate;
        (this.$refs.allocateDialogNoStock as Components.ListDialog).showDialog();
      });
    }
    else
    {
      // 在庫情報をロードする
      this.$api.execute(query).then(res => {
        var items: Array<Common.OrderItem> = (res as Common.LoadResult).result;
        items.forEach(obj => obj.scheduledDeliveryDate = this.adOrderItem.scheduledDeliveryDate);
        (this.$refs.allocateDialog as Components.ListDialog).items = items;
        (this.$refs.allocateDialog as Components.ListDialog).showDialog();
      });
    }
  }

  // 引当処理の実行
  public async submitAllocate(list: Array<Common.StockBalance>)
  {
    // メッセージを表示後に子画面が閉じてしまうため、仮実装
    // 引当処理前のバリデーション
    if(list.filter(obj => obj.allocationQuantity == 0).length == list.length){
      this.$api.modal.show('', 'ゼロを指定することはできません。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    if(list.map(obj => obj.allocationQuantity).reduce((total, value)=>total += value) > this.adOrderItem.backSalesOrderQuantity){
      this.$api.modal.show('', '受注残数量以下の数値を指定して下さい。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }

    // クエリの設定
    var query = new Common.AllocateQuery();
    query.orderItem = (this.$refs.mainList as Components.ListView).selected as Common.OrderItem;
    query.stockBalances = list;

    // 引当処理の実行
    return this.$api.execute(query,true).then(res => {
      //リスト更新
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //出荷明細タブのリロード
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});      

    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();      
    //   (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();//リロードする
    // });
      
  }
  public async submitAllocateNoStock()
  {
    // メッセージを表示後に子画面が閉じてしまうため、仮実装
    // 引当処理前のバリデーション
    if(this.adAllocationQuantity == 0){
      this.$api.modal.show('', 'ゼロを指定することはできません。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    if(this.adAllocationQuantity > this.adOrderItem.backSalesOrderQuantity){
      this.$api.modal.show('', '受注残数量以下の数値を指定して下さい。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    this.adListStockBalanceNoStock[0].allocationQuantity = this.adAllocationQuantity;
    this.adListStockBalanceNoStock[0].scheduledDeliveryDate = this.adScheduledDeliveryDate;
    
    // クエリの設定
    var query = new Common.AllocateQuery();
    query.orderItem = (this.$refs.mainList as Components.ListView).selected as Common.OrderItem;
    query.stockBalances = this.adListStockBalanceNoStock;

    // 引当処理の実行
    return this.$api.execute(query).then(res => {
      //リスト更新
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //出荷明細タブのリロード
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});  
  }

  // 一括引当処理用プロパティ
  public visibleBulkAllocateDialog:boolean = false;
  public baSegment: Common.Segment = null;
  public baWarehouse: Common.Counterpart = null;
  public baOrderByOrderItem: Common.AllocationOrder = Common.AllocationOrder.OrderDate;
  public baAdOrderItem: boolean = true;
  public baOrderByStock: Common.StockOrder = Common.StockOrder.SKU;
  public baAdStock: boolean = true;

  // 一括引当処理ダイアログの表示
  public showBulkAllocateDialog(){
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    this.baSegment = this.checkedOrderItems[0].order.segment;
    if(this.checkedOrderItems.filter(item => item.order.segmentId != this.baSegment.id).length > 0){
      this.$api.modal.show('', '複数部門に対する一括引当処理はできません。', true, null);
      return;
    }
    if(this.baSegment.priceCalculationMethod == Common.PricingTypes.Specific){
      this.$api.modal.show('', '在庫単価計算が個別法の部門は、一括引当処理の対象外です。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の出荷引当は行えません。', true, null);
      return;
    }    
    for(var item of this.checkedOrderItems){
      var message: string = this.validateForAllocation(item);
      if(message.length > 0){
        this.$api.modal.show('', message, true, null);
        return;
      }
    }

    // プロパティの初期化
    this.baWarehouse = null;
    this.baOrderByOrderItem = Common.AllocationOrder.OrderDate;
    this.baAdOrderItem =  true;
    this.baOrderByStock = Common.StockOrder.SKU;
    this.baAdStock =  true;

    // 一括引当処理ダイアログの表示
    if(this.checkedOrderItems.filter(obj => obj.commodity.isNoStock == false).length > 0)
    {
      this.visibleBulkAllocateDialog = true;
    }
    else
    {
      this.$api.modal.showDialog('確認メッセージ','出荷引当を実行してよろしいですか？',false).then(()=>{
        this.submitBulkAllocate();
      });
    }
  }

  // 
  public getStockOrder():Common.BindItem[]{
    // 在庫読込順からSKUを除外
    // var list = [new Common.BindItem(Common.StockOrder.SKU, 'SKU'),];
    var list = []; 
    if(this.tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, this.tenantSettings.nameReserveText1));
    if(this.tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText2, this.tenantSettings.nameReserveText2));
    if(this.tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText3, this.tenantSettings.nameReserveText3));
    if(this.tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText4, this.tenantSettings.nameReserveText4));
    if(this.tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText5, this.tenantSettings.nameReserveText5));
    if(this.tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText6, this.tenantSettings.nameReserveText6));
    if(this.tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo1, this.tenantSettings.nameReserveMemo1));
    if(this.tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo2, this.tenantSettings.nameReserveMemo2));
    if(this.tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo3, this.tenantSettings.nameReserveMemo3));
    if(this.tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList1));
    if(this.tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList2, this.tenantSettings.nameReserveList2));
    if(this.tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList3));
    if(this.tenantSettings.usedTypeDetailReserveDate1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate1, this.tenantSettings.nameReserveDate1));
    if(this.tenantSettings.usedTypeDetailReserveDate2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate2, this.tenantSettings.nameReserveDate2));
    if(this.tenantSettings.usedTypeDetailReserveDate3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate3, this.tenantSettings.nameReserveDate3));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText2, '予備テキスト2'));
    // if(this.baSegment && this.baSegment.reserveText3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText3, '予備テキスト3'));
    // if(this.baSegment && this.baSegment.reserveText4StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText4, '予備テキスト4'));
    // if(this.baSegment && this.baSegment.reserveText5StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText5, '予備テキスト5'));
    // if(this.baSegment && this.baSegment.reserveText6StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText6, '予備テキスト6'));
    // if(this.baSegment && this.baSegment.reserveMemo1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo1, '予備メモ1'));
    // if(this.baSegment && this.baSegment.reserveMemo2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo2, '予備メモ2'));
    // if(this.baSegment && this.baSegment.reserveMemo3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo3, '予備メモ3'));
    // if(this.baSegment && this.baSegment.reserveList1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, '予備リスト1'));
    // if(this.baSegment && this.baSegment.reserveList2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList2, '予備リスト2'));
    // if(this.baSegment && this.baSegment.reserveList3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList3, '予備リスト3'));
    // if(this.baSegment && this.baSegment.reserveDate1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate1, '予備日付1'));
    // if(this.baSegment && this.baSegment.reserveDate2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate2, '予備日付2'));
    // if(this.baSegment && this.baSegment.reserveDate3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate3, '予備日付3'));
    return list;
  }

  // 一括引当処理の実行
  public async submitBulkAllocate(){
    this.getCheckedOrderItems();

    // クエリの設定
    var query = new Common.BulkAllocateQuery(this.checkedOrderItems);
    query.warehouse = this.baWarehouse;
    query.orderByOrderItem = this.baOrderByOrderItem;
    query.adOrderItem = this.baAdOrderItem;
    query.orderByStock = this.baOrderByStock;
    query.adStock = this.baAdStock;

    // 一括引当処理の実行
    await this.$api.execute(query,true).then(res => {
      this.refreshListView();
      //リロードする
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果',res.cntSelect + '件中' + res.cntSuccess + '件の出荷引当が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;}); 

  }

  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog() {
    this.getCheckedOrderItems();

    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の発注処理は行えません。', true, null);
      return;
    }    

    let componentClass = Vue.extend(this.createPurchaseOrder);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 伝票表示(受注一覧へ遷移)
  public showSalesOrder() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    this.$router.push(String.format('/sales/SalesOrder?orderNo={0}',obj.order.orderNo));
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 発注明細表示ボタンの非活化状態を更新
    this.disabledShowPurchaseOrderItemButton = selected.state <= Common.OrderItemStatus.SalesOrderAllocating
    || selected.state == Common.OrderItemStatus.SalesOrderUndelivered;

    // 出荷明細表示ボタンの非活化状態を更新
    this.disabledShowSalesDeliveryItemButton
      = selected.state <= Common.OrderItemStatus.SalesOrderUnallocated
      || selected.state == Common.OrderItemStatus.SalesOrderArrivalWaiting
      || selected.state == Common.OrderItemStatus.SalesOrderUndelivered;
  }
  
  // 発注明細表示表示ボタンの非活性判別
  public disabledShowPurchaseOrderItemButton: boolean = true;

  // 出荷明細表示ボタンの非活性判別
  public disabledShowSalesDeliveryItemButton: boolean = true;
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesOrderItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrder, sourceNo : item.orderNo, isItem: true},this.$el);
  }
  // 発注明細一覧を表示
  public showPurchaseOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?salesOrderItemNo={0}',obj.orderItemNo));
    window.open(routeData.href, '_blank');
  }

  // 出荷明細一覧を表示
  public showSalesDeliveryItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?orderItemNo={0}',obj.orderItemNo));
    window.open(routeData.href, '_blank');
  }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo || usedType == Common.UsedTypes.CommodityMemo ;
  }  
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }
}
